import API from '../apiCreate'
import type { AxiosRequestConfig } from 'axios'
import type { ResponseWrapper } from '../types/base.types'
import type {
  RequestCreateCrmDeal,
  RequestSortCrmDeals,
  RequestUpdateCrmDeal,
  ResponseCrmDealCatalogDeleted,
  ResponseCrmDealCatalogItem,
  ResponseCrmDealCatalogList,
  ResponseCrmDealCatalogSorted,
} from '../types/crm/crm.types'

type ApiRequestConfig = AxiosRequestConfig & {
  skipGlobalErrorAlert?: boolean
  disableGlobalErrorTextTruncate?: boolean
}

/** Глобальный каталог названий сделок CRM (`/v1/crm-deal`). */
export const crmDealApi = {
  /** GET /v1/crm-deal */
  getAll: () =>
    API.get<ResponseWrapper<ResponseCrmDealCatalogList>>('crm-deal'),

  /** POST /v1/crm-deal/create */
  create: (data: RequestCreateCrmDeal, config?: ApiRequestConfig) =>
    API.post<ResponseWrapper<ResponseCrmDealCatalogItem>>(
      'crm-deal/create',
      data,
      config,
    ),

  /** PATCH /v1/crm-deal/update/{id} */
  update: (
    id: number,
    data: RequestUpdateCrmDeal,
    config?: ApiRequestConfig,
  ) =>
    API.patch<ResponseWrapper<ResponseCrmDealCatalogItem>>(
      `crm-deal/update/${id}`,
      data,
      config,
    ),

  /** PATCH /v1/crm-deal/sorting — `{ items: number[] }` id в новом порядке */
  updateSorting: (data: RequestSortCrmDeals, config?: ApiRequestConfig) =>
    API.patch<ResponseWrapper<ResponseCrmDealCatalogSorted>>(
      'crm-deal/sorting',
      data,
      config,
    ),

  /** DELETE /v1/crm-deal/delete/{id} */
  delete: (id: number, config?: ApiRequestConfig) =>
    API.delete<ResponseWrapper<ResponseCrmDealCatalogDeleted>>(
      `crm-deal/delete/${id}`,
      config,
    ),
}
